export default function displayExemptions(results) {
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });


    let s = `<h3>Exemptions</h3>`
    if (results.length)
        {
            s+= `<table class="summaryTable table-responsive">    
            <thead>
                <th>Code Description</th> <th>Max Amount</th> 
            </thead>`;

            for (let i = 0, il = results.length; i < il; i++) {
                if(results[i].exemption_code_desc == "Senior Assessment Freeze")
                {
                    s+=`<tr>
                            <td>${results[i].exemption_code_desc}</td><td>Yes</td>
                        </tr>`
                }
                else {
                    s+=`<tr>
                            <td>${results[i].exemption_code_desc}</td><td>${USDollar.format(results[i].exemption_max_amt)}</td>
                        </tr>`

                }
            }
            s += "</table>";

        }
        else {
            s+= `<p>No exemptions to display.</p>`
        }
    return s; 
}